import { render, staticRenderFns } from "./MediaGalleryModal.vue?vue&type=template&id=3779f190&scoped=true&"
import script from "./MediaGalleryModal.vue?vue&type=script&lang=js&"
export * from "./MediaGalleryModal.vue?vue&type=script&lang=js&"
import style0 from "./MediaGalleryModal.vue?vue&type=style&index=0&id=3779f190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3779f190",
  null
  
)

export default component.exports